goog.provide("shadow.js.shim.module$$mui$material$InputAdornment$default");
shadow.js.shim.module$$mui$material$InputAdornment$default = shadow.js.shim.module$$mui$material$InputAdornment.default;
